<div class="py-6">
    <app-table
      [loading]="loading"
      [data]="tableData"
      [columns]="tableColumns"
      [pageSize]="50"
      [internalScrolling]="true"
      [internalHorizontalScrolling]="true"
      [enableFirstRowFreeze]="true"
      [enableFirstColumnFreeze]="true"
      id="table-declarationOfInterest"
    ></app-table>
</div>




